import { ConsultationTypesField } from '@/pages/onboarding/ConsultationTypesField';
import { SessionModeField } from '@/pages/onboarding/SessionModeField';
import type { OnboardingStepProps } from '@/pages/onboarding/onboarding.types';
import { Stack } from '@careflux/primitives';

export const WorkStep = ({ copy, control }: OnboardingStepProps) => (
  <Stack as="section" gap="xl">
    <ConsultationTypesField copy={copy} control={control} />
    <SessionModeField copy={copy} control={control} />
  </Stack>
);
